const _ = require("lodash");

const colors = {
  color1: "#808080",
  color2: "#ff0000",
  color3: "#00ff00",
  color4: "#ffff00",
  color5: "#0000ff",
  color6: "#00ffff",
  color7: "#ff00ff",
  color8: "#ff8000",
  color9: "#80ff00",
  color10: "#ff8080",
  color11: "#80ff80",
  color12: "#ffff80"
};

const initialize = () => {
  colors.color1 = "#808080";
  colors.color2 = "#ff0000";
  colors.color3 = "#00ff00";
  colors.color4 = "#ffff00";
  colors.color5 = "#0000ff";
  colors.color6 = "#00ffff";
  colors.color7 = "#ff00ff";
  colors.color8 = "#ff8000";
  colors.color9 = "#80ff00";
  colors.color10 = "#ff8080";
  colors.color11 = "#80ff80";
  colors.color12 = "#ffff80";
};

const setColor = (colorIndex, color) => {
  const omitWhiteColor = colorIsVisible(color) ? color : "#e0e0e0";
  colors[`color${colorIndex}`] = omitWhiteColor;
};

const getColorFromIndex = colorIndex => {
  return _.get(colors, `color${colorIndex}`, "#000000");
};

function colorIsVisible(color) {
  if (color.length != 7) return false;
  let rgb = color.substring(1).split((/(.{2})/)).filter(x=>x).map(x=>parseInt(x,16));
  return rgb.every(x=> x <= 224);
};

const colorStore = {
  initialize,
  getColorFromIndex,
  setColor
};

Object.freeze(colorStore);
export default colorStore;
